import { AwsCustomized, AwsDelete, AwsPut, AwsUploadFiles } from './typing'
import { typeFiles } from '../../utils/constants/typeFIles'
import { httpFetch } from '../../utils/crud'
import { BodyUrl, sharedService } from './service'
import { SignatureOperation } from './enums/signatureOperation'
import { CRUDOPTIONS } from './enums/options'


export const sharedAws: AwsCustomized = {
  put: async (body: AwsPut) => {
    const file = body.file;
    const path = `${body.name ? `${body.name}/` : ''}${file.name}`.replace(/\s+/g, '');
    const type = typeFiles[file.type] ?? file.type;
    const xhr = new XMLHttpRequest();
    const bodyUrl: BodyUrl = {
      bucketName: body.otherBucket ?? process.env.REACT_APP_EVIDENCES ?? '',
      key: path,
      operation: SignatureOperation.UPLOAD,
      type
    }

    const res = await sharedService(httpFetch).getUrlSignature({ body: bodyUrl })
    const url = res.url;
    const match = url.match(/^https:\/\/([^.]+)\.s3/) ?? '';
    const bucket = match[1];

    body.cancelUpload?.(xhr);

    xhr.upload.onprogress = function (event) {
      if (event.lengthComputable) {
        const percentComplete = Math.round((event.loaded / event.total) * 100);
        body.progressCallback?.(percentComplete);
      }
    };

    xhr.onload = function () {
      if (xhr.status >= 200 && xhr.status < 300) {
        const publicUrl = `https://${bucket}.s3.amazonaws.com/${path}`;
        body?.completeCallback?.(publicUrl);
      } else {
        body?.errorCallback?.(xhr.responseText);
      }
    };

    xhr.onerror = function () {
      body?.errorCallback?.('Error de red o fallo al subir el archivo');
    };

    xhr.onabort = function () {};

    xhr.open(CRUDOPTIONS.PUT, url, true);
    xhr.setRequestHeader('Content-Type', type);
    xhr.send(file);

  },
  delete: async (body: AwsDelete) => {

    const bodyUrl:BodyUrl = {
      bucketName: body?.otherBucket ?? process.env.REACT_APP_EVIDENCES ?? '',
      key: body.name,
      operation: SignatureOperation.DELETE
    }

    const res = await sharedService(httpFetch).getUrlSignature({ body: bodyUrl })

    const url = res.url;

    const deleteRes = await fetch(url, {
      method: CRUDOPTIONS.DELETE
    });

    if (!deleteRes.ok) {
      throw new Error('Error deleting file from S3');
    }

    return true;
  },
  deleteList: async ({ otherBucket, list }) => {
    const objectsToDelete = list.map((key) => ({ Key: key }));
    const bodyUrl:BodyUrl = {
      bucketName: otherBucket ?? process.env.REACT_APP_EVIDENCES ?? '',
      key: objectsToDelete,
      operation: SignatureOperation.DELETE
    }

    const res = await sharedService(httpFetch).getUrlSignature({ body: bodyUrl })


    return true;
  },
  uploadAndGetUrl: async (body: AwsUploadFiles) => {
    const file = body.file;
    const path = `${body?.name ?? new Date().getTime()}/${file.name}`.replace(/\s+/g, '');
    const type = typeFiles[file.type] ?? file.type;


    const bodyUrl: BodyUrl = {
      bucketName: body.otherBucket ?? process.env.REACT_APP_EVIDENCES ?? '',
      key: path,
      operation: SignatureOperation.UPLOAD,
      type
    }

    const res = await sharedService(httpFetch).getUrlSignature({ body: bodyUrl })
    const url = res.url;
    const match = url.match(/^https:\/\/([^.]+)\.s3/) ?? '';
    const bucket = match[1];

    const uploadRes = await fetch(url, {
      method: CRUDOPTIONS.PUT,
      headers: {
        'Content-Type': type
      },
      body: file
    });

    if (!uploadRes.ok) {
      throw new Error('Error uploading to S3');
    }

    const publicUrl = `https://${bucket}.s3.amazonaws.com/${path}`;
    return publicUrl;
  },
  getDownloadUrl: async (key: string, otherBucket?: string) => {
    const bodyUrl: BodyUrl = {
      bucketName: otherBucket ?? process.env.REACT_APP_EVIDENCES ?? '',
      key,
      operation: SignatureOperation.DOWNLOAD
    }
  
    const res = await sharedService(httpFetch).getUrlSignature({ body: bodyUrl });
    
    return res.url as string;
  },
}
